/**
 * Shows the quantity total inside the "Add to Cart" button
 * (e.g. "Add to Cart – $149.97"), including when the quantity is 1.
 *
 * The unit price (in cents) and money format are still read from the element
 * rendered by snippets/price.liquid:
 *   [data-price-qty-total] (has data-unit-price in cents + data-money-format)
 * That element is now kept hidden; the total is written into the add-to-cart
 * button (button[name="add"]) of the same form instead.
 *
 * Listens for quantity changes on inputs rendered by snippets/quantity-input.liquid
 * (.qty-input__input[name="quantity"]) and on the theme's 'on:variant:change'
 * event so the total stays correct when the customer switches variants.
 */
(function () {
  if (window.priceQuantityTotalInit) return;
  window.priceQuantityTotalInit = true;

  var STYLE_ID = 'price-quantity-total-style';
  var BTN_TOTAL_ATTR = 'data-btn-qty-total';

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      // The old "Total" next to the price is no longer shown.
      '.price__qty-total{display:none !important;}' +
      '.btn__qty-total{' +
        'white-space:nowrap;' +
        'font-weight:inherit;' +
      '}';
    document.head.appendChild(style);
  }

  function defaultOption(opt, def) {
    return typeof opt === 'undefined' || opt === null ? def : opt;
  }

  /**
   * Formats cents into a decimal string with the given precision/separators.
   * (Standard Shopify money-formatting algorithm.)
   */
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number === null) return '0';

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.');
    var dollarsPart = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var centsPart = parts[1] ? decimal + parts[1] : '';

    return dollarsPart + centsPart;
  }

  /**
   * Formats cents as money using a Shopify money_format string,
   * e.g. "${{amount}}" or "{{amount_with_comma_separator}} EUR".
   */
  function formatMoney(cents, format) {
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';
    var match = formatString.match(placeholderRegex);
    var kind = match ? match[1] : 'amount';
    var value;

    switch (kind) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }

  function removeButtonTotal(btn) {
    var existing = btn.querySelector('[' + BTN_TOTAL_ATTR + ']');
    if (existing) existing.remove();
  }

  function setButtonTotal(btn, text) {
    var span = btn.querySelector('[' + BTN_TOTAL_ATTR + ']');
    if (!span) {
      span = document.createElement('span');
      span.className = 'btn__qty-total';
      span.setAttribute(BTN_TOTAL_ATTR, '');
    }
    var label = ' – ' + text; // " – $X.XX"
    if (span.textContent !== label) span.textContent = label;
    if (span.parentNode !== btn) btn.appendChild(span);
  }

  function updateTotal(qtyInput) {
    if (!qtyInput) return;

    // Scope to the nearest per-product wrapper first (e.g. the <product-card>
    // element on a collection grid), then the section, then the document.
    var scope = qtyInput.closest('product-card') ||
      qtyInput.closest('[data-section-id]') ||
      document;
    var totalEl = scope.querySelector('[data-price-qty-total]');
    var form = qtyInput.closest('form');
    var btn = (form && form.querySelector('button[name="add"]')) ||
      scope.querySelector('button[name="add"]');
    if (!btn) return;

    var qty = parseInt(qtyInput.value, 10);
    if (!qty || qty < 1) qty = 1;

    var unitPrice = totalEl ? parseInt(totalEl.dataset.unitPrice, 10) : NaN;

    // Show the total for any quantity of an available item.
    if (isNaN(unitPrice) || btn.disabled) {
      removeButtonTotal(btn);
      return;
    }

    setButtonTotal(btn, formatMoney(unitPrice * qty, totalEl.dataset.moneyFormat));
    watchButton(btn, qtyInput);
  }

  // If other theme code rewrites the button's text, put the total back.
  function watchButton(btn, qtyInput) {
    if (btn.__qtyTotalObserver || !window.MutationObserver) return;
    var observer = new MutationObserver(function () {
      if (!btn.querySelector('[' + BTN_TOTAL_ATTR + ']')) {
        observer.disconnect();
        btn.__qtyTotalObserver = null;
        updateTotal(qtyInput);
      }
    });
    observer.observe(btn, { childList: true });
    btn.__qtyTotalObserver = observer;
  }

  function handleEvent(evt) {
    var input = evt.target.closest && evt.target.closest('.qty-input__input[name="quantity"]');
    if (!input) return;
    updateTotal(input);
  }

  function initAll() {
    document.querySelectorAll('.qty-input__input[name="quantity"]').forEach(updateTotal);
  }

  injectStyle();

  document.addEventListener('input', handleEvent);
  document.addEventListener('change', handleEvent);

  // Recalculate after a variant switch replaces the price/button markup.
  document.addEventListener('on:variant:change', function () {
    [0, 150, 500].forEach(function (delay) {
      setTimeout(initAll, delay);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
